import styled from 'styled-components'

const firstColor = (palette: Record<string, unknown>) => {
  if (!palette) return ''
  if (Object.keys(palette).length === 0) return '#222222'
  return (
    `${palette.vibrant}40` ||
    `${palette.lightvibrant}40` ||
    `${palette.darkVibrant}40` ||
    `${palette.muted}40` ||
    `${palette.lightMuted}40` ||
    `${palette.darkMuted}40` ||
    '#222222'
  )
}

export const StyledStreamEmpty = styled.div<{ palette: Record<string, unknown> }>`
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  border-radius: 2px 2px 0px 0px;
  right: 0;
  top: 0;
  bottom: 0;
  color: white;
  background-color: ${({ palette }) => firstColor(palette)};
  ${({ theme }) => theme.transition[0]}
`
